export default "__VITE_ASSET__S40PDRjB__"